import { useQuery } from '@tanstack/react-query'

import { assessmentService } from '@/services/api/assessment.service'
import type { DashboardStatsData, DashboardStatsParams } from '@/types/dashboard_stats.types'
import { defaultQueryOptions, errorUtils } from '@/utils/query/common'

export interface UseDashboardStatsReturn {
  stats: DashboardStatsData | null
  isLoading: boolean
  isError: boolean
  error: string | null
  refetch: () => void
  isFetching: boolean
}

export function useDashboardStats(params: DashboardStatsParams = {}): UseDashboardStatsReturn {
  const query = useQuery({
    queryKey: ['assessments', 'stats', params],
    queryFn: () => assessmentService.getStats(params),
    staleTime: 5 * 60 * 1000,
    ...defaultQueryOptions
  })

  return {
    stats: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error ? errorUtils.transformAxiosError(query.error) : null,
    refetch: query.refetch,
    isFetching: query.isFetching
  }
}
